import { HttpErrorResponse } from "@angular/common/http";

import { EmployeeModel } from "@core/models/employee.model";
import * as EmployeesActions from "@features/employees/store/employees.actions";
import { createReducer, on } from "@ngrx/store";

export interface EmployeesState {
  employeesLoading: boolean;
  employeesList: Array<EmployeeModel>;
  error: HttpErrorResponse | null;
}

const initialState: EmployeesState = {
  employeesLoading: false,
  employeesList: [],
  error: null,
};

export const EMPLOYEES_REDUCER = createReducer(
  initialState,

  on(
    EmployeesActions.EMPLOYEES_ACTION_FAILURE,
    (state, action): EmployeesState => ({
      ...state,
      error: action.error,
    })
  ),

  on(
    EmployeesActions.SET_EMPLOYEES_LOADING,
    (state, action): EmployeesState => ({
      ...state,
      employeesLoading: action.loading,
    })
  ),

  on(
    EmployeesActions.LOAD_EMPLOYEES,
    (state): EmployeesState => ({
      ...state,
      error: null,
    })
  ),

  on(
    EmployeesActions.SET_EMPLOYEES_LIST,
    (state, action): EmployeesState => ({
      ...state,
      employeesList: action.employeesList,
      error: null,
    })
  )
);
